export class LPQuestionnaireReviewHistory {
  public id: number;
  public review_Submitted_Date?: Date;
  public reviewer_Submitter: string;
  public action: string;
  public status: string;
  public recipient: string;
  public comment: string;
  public orgId: number;
  public qtrId: number;
  public statusId: number;
}

export class LPQuestionnaireFormState {
  public approvable: boolean;
  public editable:   boolean;
  public returnable: boolean;
}

export class FOResponseObject {
  public id: number;
  public status: number;
  public orgId: number;
  public qtrId: number;
  public q1_HasIndirectTaxLC: number;
  public q1i_LCProbableLikelihoodExceed1M: number;
  public q1ia_Aggregate: number;
  public q1ii_LCPossibleLikelihoodExceed5M: number;
  public q1iib_Aggregate: number;
  public q1iii_LCRemoteLikelihoodExceed10M: number;
  public q1iiic_Aggregate: number;
  public q2_IndirectTaxGCExceed5M: number;
  public q2d_Aggregate: number;
  public q3_IndirectTaxAssetsExceed1M: number;
  public q4_AnnualThroughPutExceed100M: number;
  public priorQ4_AnnualThroughPutExceed100M: number;
  public q4_ChangeInResponseDesc: string;
  public prepared_UpdatedBy: string;
  public activeLossContingencies: number;
  public lcTotalOpeningBalanceProbable: number;
  public lcTotalOpeningBalancePossible: number;
  public lcTotalOpeningBalanceRemote: number;
  public gcTotalOpeningBalance: number;
  public aaPriorQuarterTotal: number;
  public reviewHistory: LPQuestionnaireReviewHistory[];
}

export class FOPayload {
  public formState: LPQuestionnaireFormState;
  public viewModel: FOResponseObject;
}

export class FOApprovePayload{
  public formState: LPQuestionnaireFormState;
  public reviewHistoryItem: LPQuestionnaireReviewHistory;
}

export class ApprovePayload {
  public value: string;
}
